import React from 'react'
import { Popup as LeafletPopup } from 'react-leaflet'
import NKIcon from '@norkart/ikoner'
import { datoFormatTall } from '../../../felles/utils/dato-format-tabell'

export default ({ fjernVannmaaler, maaler }) => (
    <LeafletPopup position={[maaler.Latitude, maaler.Longitude]} className="vat-popup">
        <div className="maaler-popup-content">
            <h4>Målerinformasjon</h4>
            <table className="Table" width="200px">
                <tbody>
                    <tr>
                        <td>Eier:</td>
                        <td>{maaler.Eiernavn}</td>
                    </tr>
                    <tr>
                        <td>Adresse:</td>
                        <td>
                            {maaler.Maalepunktadresse + (' ' + maaler.Husnummer) + (maaler.Husbokstav ? maaler.Husbokstav: '')}
                        </td>
                    </tr>
                    <tr>
                        <td>Mob:</td>
                        <td>{maaler.Mobil}</td>
                    </tr>
                    <tr>
                        <td>Avtalt tid:</td>
                        <td>{datoFormatTall(maaler.Avtaltdato)}</td>
                    </tr>
                    <tr>
                        <td>Avlesertype:</td>
                        <td>{maaler.Avlesertype}</td>
                    </tr>
                    <tr>
                        <td>Plassering:</td>
                        <td>{maaler.Plassering}</td>
                    </tr>
                </tbody>
            </table>
            <button className="slett" onClick={() => fjernVannmaaler(maaler)}>
                <NKIcon size="1" color="nk-black" icon="soppelbotte" />
            </button>
        </div>
    </LeafletPopup>
)


// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/rediger/PlanlagtPopup.jsx